"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoubleIndex = void 0;
var SingleIndex_1 = require("./SingleIndex");
var DoubleIndex = /** @class */ (function () {
    function DoubleIndex() {
        this.store = new Map();
    }
    DoubleIndex.prototype.add = function (upperKey, lowerKey, value) {
        var _a;
        var g = (_a = this.store.get(upperKey)) !== null && _a !== void 0 ? _a : this.allocate(upperKey);
        return g.add(lowerKey, value);
    };
    DoubleIndex.prototype.remove = function (upperKey, lowerKey, value) {
        var _a;
        var slot = (_a = this.store.get(upperKey)) === null || _a === void 0 ? void 0 : _a.get(lowerKey);
        if (slot) {
            slot.delete(value);
            if (slot.size === 0) {
                this.delete(upperKey, lowerKey);
            }
            return slot.size;
        }
        return -1;
    };
    DoubleIndex.prototype.delete = function (upperKey, lowerKey) {
        var _a;
        (_a = this.store.get(upperKey)) === null || _a === void 0 ? void 0 : _a.delete(lowerKey);
    };
    DoubleIndex.prototype.clear = function (upperKey) {
        var _a;
        if (upperKey) {
            (_a = this.store.get(upperKey)) === null || _a === void 0 ? void 0 : _a.clear();
        }
        else {
            this.store.clear();
        }
    };
    DoubleIndex.prototype.get = function (upperKey, lowerKey) {
        var _a, _b;
        return (_b = (_a = this.store.get(upperKey)) === null || _a === void 0 ? void 0 : _a.get(lowerKey)) !== null && _b !== void 0 ? _b : DoubleIndex.emptySlot;
    };
    DoubleIndex.prototype.getUpper = function (upperKey) {
        var _a;
        return (_a = this.store.get(upperKey)) !== null && _a !== void 0 ? _a : DoubleIndex.emptyUpper;
    };
    DoubleIndex.prototype.has = function (upperKey, lowerKey) {
        var _a, _b;
        return (_b = (_a = this.store.get(upperKey)) === null || _a === void 0 ? void 0 : _a.has(lowerKey)) !== null && _b !== void 0 ? _b : false;
    };
    DoubleIndex.prototype.dir = function () {
        return Object.fromEntries(Array
            .from(this.store.entries())
            .map(function (_a) {
            var _b = __read(_a, 2), k = _b[0], v = _b[1];
            return [k, v.dir()];
        }));
    };
    DoubleIndex.prototype.allocate = function (upperKey) {
        var li = new SingleIndex_1.SingleIndex();
        this.store.set(upperKey, li);
        return li;
    };
    DoubleIndex.prototype[Symbol.iterator] = function () {
        return this.store[Symbol.iterator]();
    };
    DoubleIndex.emptyUpper = Object.freeze(new SingleIndex_1.SingleIndex());
    DoubleIndex.emptySlot = Object.freeze(new Set());
    return DoubleIndex;
}());
exports.DoubleIndex = DoubleIndex;
